import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, CircularProgress } from "@mui/material";
import CarePlanTable from "../tables/CarePlanTable";
import ButtonCreateCarePlan from "../ButtonCreateCarePlan";
import {CarePlanContext} from "../../../../context/CarePlanContext/CarePlanContext"

export default function CarePlansCard({ patientId }) {
  const { t } = useTranslation();
  const { Careplans, fetchCareplans, loading } = useContext(CarePlanContext);

  useEffect(() => {
    if (patientId) {
      fetchCareplans(patientId);
    }
  }, [patientId]);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1000px",
        margin: "auto",
        mt: 4,
        p: 3,
        backgroundColor: "#fff",
        borderRadius: 2,
        boxShadow: 3,
        textAlign: "center",
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
        {t("CarePlan.carePlansTitle")}
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : !Careplans || Careplans.length === 0 ? (
        <Typography variant="body1" color="textSecondary">
          {t("CarePlan.noActiveCarePlans")}
        </Typography>
      ) : (
        <CarePlanTable carePlans={Careplans} />
      )}

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <ButtonCreateCarePlan patientId={patientId} />
      </Box>
    </Box>
  );
}
